import { render, staticRenderFns } from "./multiform.vue?vue&type=template&id=cc330926&"
import script from "./multiform.js?vue&type=script&lang=js&"
export * from "./multiform.js?vue&type=script&lang=js&"
import style0 from "./multiform.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports